(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["offer-collection-list-rouf"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".main-collection-wrapper").forEach(function(wrapper){

    const slider = wrapper.querySelector(".main-collection-slider");
    const leftBtn = wrapper.querySelector(".main-arrow.left");
    const rightBtn = wrapper.querySelector(".main-arrow.right");

    if (!slider || !leftBtn || !rightBtn) return;

    const scrollAmount = 250;

    rightBtn.addEventListener("click", function () {
      slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });

    leftBtn.addEventListener("click", function () {
      slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["round-collection-list-rouf"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".collection-row").forEach(function (row) {

    const slider = row.querySelector(".collection-row-slider");
    const leftBtn = row.querySelector(".collection-arrow.left");
    const rightBtn = row.querySelector(".collection-arrow.right");

    if (!slider || !leftBtn || !rightBtn) return;

    const scrollAmount = 250;

    rightBtn.addEventListener("click", function () {
      slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });

    leftBtn.addEventListener("click", function () {
      slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });

  });

});

  } catch(e) { console.error(e); }
})();
})();
